import { render, staticRenderFns } from "./expandableCriteres.vue?vue&type=template&id=d45d10b6&"
import script from "./expandableCriteres.vue?vue&type=script&lang=ts&"
export * from "./expandableCriteres.vue?vue&type=script&lang=ts&"
import style0 from "./expandableCriteres.vue?vue&type=style&index=0&id=d45d10b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports